module.exports = __webpack_public_path__ + "static/media/uisce.ed38895e.png";